import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators
} from '@angular/forms';
import { country_list } from '../../../core/utilities/countries';
import { Store } from '@ngrx/store';
import { State } from '../../../store/reducers';

import * as bookingActions from '../../../store/actions/booking.action';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Booking } from '../../models/booking';

@Component({
  selector: 'app-personalinfo',
  templateUrl: './personalinfo.component.html',
  styleUrls: ['./personalinfo.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class PersonalinfoComponent implements OnInit {
  personalInfoForm: FormGroup;
  countries: string[];
  public title: Array<string> = [
    'Mr.',
    'Mrs.',
    'Miss.',
    'Elder',
    'Deaconess',
    'Deacon',
    'Pastor',
    'Apostle',
    'Prophet',
    'Bishop',
    'Evangelist',
    'Dr.',
    'Prof.',
    'Emeritus',
    'Sir'
  ];
  public gender: Array<string> = ['Male', 'Female'];

  constructor(
    private fb: FormBuilder,
    private store: Store<State>,
    private router: Router
  ) {}

  ngOnInit() {
    this.countries = country_list;
    this.createForm();
    // this.store
    //   .select(state => state.booking.currentBooking)
    //   .subscribe(booking => this.createForm(booking));
  }

  createForm() {
    this.personalInfoForm = this.fb.group({
      title: '',
      firstNames: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      gender: ['', Validators.required],
      country: ['', Validators.required],
      idNumber: ['', Validators.required],
      mobilePhone: ['', Validators.required]
    });
  }

  submitPersonalInfo() {
    this.store.dispatch(
      new bookingActions.AddPersonalInfo(this.personalInfoForm.value)
    );
    this.router.navigate(['/bookings/add/conference-info']);
  }
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/booking/form-components/personalinfo/personalinfo.component.ts